import React from "react";
import { Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import BrandImage from "../../images/brand1.png";
const BrandCard = ({ img, id }) => {
  return (
    <Col className="col-6 col-sm-6 col-md-4 col-lg-3">
      <Card
        className="my-1"
        style={{
          height: "151px",
          borderRadius: "8px",
          border: "none",
          backgroundColor: "#FFFFFF",
        }}
      >
        <Link to={`/products/brand/${id}`} style={{ textDecoration: "none" }}>
          {img ? (
            <>
              <Card.Img
                style={{ width: "100%", height: "151px" }}
                alt="..."
                src={img}
              />
            </>
          ) : (
            <Card.Img
              style={{ width: "100%", height: "151px" }}
              src={BrandImage}
            />
          )}
        </Link>
      </Card>
    </Col>
  );
};

export default BrandCard;
